import { useState } from 'react';
import * as St from './add-commerce-api-store-info-modal.styled';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { CommerceApiApi } from '../../../../../../../apis/CommerceApiApi';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { v4 as uuidv4 } from 'uuid';
import { useCommerceApiStoreInfoActionsContextHook } from '../../../../contexts/CommerceApiStoreInfoContext';

export function AddCommerceApiStoreInfoModal({
    open,
    onClose
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const commerceApiStoreInfoActionsContextHook = useCommerceApiStoreInfoActionsContextHook();
    // 필요한 로컬 상태나 로직
    // ex) API 입력값 등
    const [formData, setFormData] = useState({
        id: uuidv4(),
        storeName: "",
        appId: "",
        appSecret: ""
    });

    const handleSave = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        const addResult = await CommerceApiApi().addCommerceApiStoreInfos({ headers: headers, body: { commerceApiStoreInfos: [{ ...formData }] } })

        if (addResult?.content) {
            commerceApiStoreInfoActionsContextHook.commerceApiStoreInfos.onSet(addResult?.content);
        }

        onClose(false);
    }

    return (
        <CustomDialog
            open={open}
            onClose={() => onClose(false)}
        >
            {/* Header 부분 */}
            <St.ModalHeader>
                <CustomDialog.Header.Fake />
                <CustomDialog.Header.Title>스토어 API 추가</CustomDialog.Header.Title>
                <CustomDialog.Header.Close onClick={() => onClose(false)} />
            </St.ModalHeader>

            {/* Body 부분 예시 */}
            <St.ApiAddModalBody>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={formData.storeName}
                        onChange={(e) => setFormData({ ...formData, storeName: e.target.value })}
                    />
                    <CustomLabelInput.Label>스토어명</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={formData.appId}
                        onChange={(e) => setFormData({ ...formData, appId: e.target.value })}
                    />
                    <CustomLabelInput.Label>애플리케이션 ID</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={formData.appSecret}
                        onChange={(e) => setFormData({ ...formData, appSecret: e.target.value })}
                    />
                    <CustomLabelInput.Label>애플리케이션 시크릿</CustomLabelInput.Label>
                </CustomLabelInput>

                <div className="buttons">
                    <CustomBlockButton
                        type='button'
                        onClick={() => onClose(false)}
                    >
                        취소
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='primary'
                        onClick={handleSave}
                    >
                        저장
                    </CustomBlockButton>
                </div>
            </St.ApiAddModalBody>
        </CustomDialog>
    );
}